import api from "../axiosConfig";

export const submitExerciseAnswers = async (
  exerciseId: string,
  planId: string,
  answers: any[],
  videoUrl?: string[] // Thêm tham số videoUrl là tùy chọn
) => {
  try {
    // Tạo payload cơ bản
    const payload: {
      planId: string;
      answers: any[];
      videoUrl?: string[];
    } = {
      planId: planId,
      answers: answers,
    };

    if (videoUrl && videoUrl.length > 0) {
      payload.videoUrl = videoUrl;
    }

    const response = await api.post(`/submit-exercise`, payload);
    return response.data;
  } catch (error) {
    console.error("Error submitting exercise answers:", error);
    throw error;
  }
};
